import { render, staticRenderFns } from "./Biographie.vue?vue&type=template&id=a28e109e&scoped=true&"
import script from "./Biographie.vue?vue&type=script&lang=js&"
export * from "./Biographie.vue?vue&type=script&lang=js&"
import style0 from "./Biographie.vue?vue&type=style&index=0&id=a28e109e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28e109e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/felix/Google Drive/Travail/Mes projets/syl-vain/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VImg,VLayout,VProgressCircular})
